const { showError, showNotifikasi } = require('../../libs/helper');
var qs = require('qs');

module.exports = {
    getDetail: (g, params) => {
        let result = g.$http({
            url: process.env.VUE_APP_SUBFOLDER_API2 + 'api/sensus-pengguna-b/sk-tim/detail',
            method: 'post',
            data: qs.stringify(params),
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded'
            },
        }).then(res => {
            return res.data;
        }).catch(err => {
            console.log(err)
        })
        return result;

    },
    getWilayah: (g, params = null) => {
        let result = g.$http({
            url: process.env.VUE_APP_SUBFOLDER_API2 + 'api/sensus-pengguna-b/ref/get-wilayah',
            method: 'post',
            data: qs.stringify(params),
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded'
            },
        }).then(res => {
            return res.data;
        }).catch(err => {
            console.log(err)
        })
        return result;

    },
    getKolokDs: async (g, params) => {
        let result = await g.$http({
            url: process.env.VUE_APP_SUBFOLDER_API2 + 'api/sensus-pengguna-b/ref/get-kolok',
            method: 'post',
            data: qs.stringify(params),
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded'
            },
        }).then(res => {
            return res.data;
        }).catch(err => {
            showError(g, err, `Error Get Data`)
        })
        return result;

    },
    getNrkSingleData: async (g, params) => {
        let payload = { ...params }
        payload.nrk = parseInt(payload.nrk);
        let result = await g.$http({
            url: process.env.VUE_APP_SUBFOLDER_API2 + 'api/sensus-pengguna-b/ref/get-pegawai-eksternal',
            method: 'post',
            data: qs.stringify(payload),
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded'
            },
        }).then(res => {
            return res.data;
        }).catch(err => {
            showError(g, err, `Error Get Data`)
        })
        return result;
    },
    saveAsDraft: async (g, data) => {
        let result = await g.$http({
            url: process.env.VUE_APP_SUBFOLDER_API2 + 'api/sensus-pengguna-b/sk-tim/draft',
            method: 'post',
            data: qs.stringify(data),
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded'
            },
        })
            .then(res => {
                return res.data;
            })
            .catch(err => {
                showError(g, err, `Error Submit Form`)
            })
        return result;

    },
    savePengajuan: async (g, data) => {
        let result = await g.$http({
            url: process.env.VUE_APP_SUBFOLDER_API2 + 'api/sensus-pengguna-b/sk-tim/submit',
            method: 'post',
            data: qs.stringify(data),
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded'
            },
        }).then(res => {
            return res.data;
        }).catch(err => {
            showError(g, err, `Error Submit Form`)
        })
        return result;
    },
    validasiP3b: async (g, data) => {
        let result = await g.$http({
            url: process.env.VUE_APP_SUBFOLDER_API2 + 'api/sensus-pengguna-b/sk-tim/validasi/p3b',
            method: 'post',
            data: qs.stringify(data),
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded'
            },
        }).then(res => {
            return res.data;
        }).catch(err => {
            showError(g, err, `Error Submit Form`)
        })
        return result;
    },
    validasiKepala: async (g, data) => {
        let result = await g.$http({
            url: process.env.VUE_APP_SUBFOLDER_API2 + 'api/sensus-pengguna-b/sk-tim/validasi/kepala',
            method: 'post',
            data: qs.stringify(data),
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded'
            },
        }).then(res => {
            return res.data;
        }).catch(err => {
            showError(g, err, `Error Submit Form`)
        })
        return result;
    },
    uploadSkTim: async (g, data) => {
        let result = await g.$http({
            url: process.env.VUE_APP_SUBFOLDER_API2 + 'api/sensus-pengguna-b/sk-tim/uploadsktim',
            method: 'post',
            data,
        }).then(res => {
            return res.data;
        }).catch(err => {
            showError(g, err, `Error Submit Form`)
            return err;
        })
        return result;
    },

}